import React, { ForwardedRef, forwardRef, memo, useMemo } from 'react';
import { Box, Checkbox, Text, TextInput } from '@bonanza-social/moonlight';
import { RegistrationFieldProps } from '../../RegistrationField.types';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { Trans } from '@bonanza-social/i18n';
import { Platform } from 'react-native';

const CheckboxField = (
  {
    value,
    onValue,
    error,
    placeholderKey,
    placeholderNS,
    ...rest
  }: RegistrationFieldProps<'age' | 'marketing' | 'pep' | 'fit' | 'terms'>,
  _: ForwardedRef<TextInput>,
) => {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();
  const linkComponents = useMemo(
    () => ({
      termsLink: (
        <Text
          variant="link-small"
          onPress={() => navigation.navigate('TermsAndConditions')}
        />
      ),
    }),
    [navigation],
  );
  return (
    <Box>
      <Box flexDirection="row" alignItems="flex-start">
        <Box>
          <Checkbox
            error={!!error}
            checked={!!value}
            onChange={(checked) => onValue(checked)}
            {...rest}
          />
        </Box>
        <Box flex={1}>
          <Box
            flexDirection="row"
            flexWrap="wrap"
            marginLeft={Platform.select({
              ios: 'space-300',
              android: 'space-300',
              web: 'space-200',
            })}
          >
            <Text variant="body-s" color="darkSurfacePrimary">
              <Trans
                i18nKey={placeholderKey}
                ns={placeholderNS}
                components={linkComponents}
              />
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(forwardRef(CheckboxField));
